export default __webpack_public_path__ + "static/media/Marauder.3e98bbdf.png";